import { supabase } from './supabase';

export interface BlendMatch {
  id: string;
  brand: string;
  blend_name: string;
  avg_rating: number | null;
  review_count: number | null;
  blend_type: string | null;
  similarity: number;
}

export async function searchBlends(query: string): Promise<{
  data: BlendMatch[] | null;
  error: Error | null;
}> {
  if (!query || query.trim().length < 2) {
    return { data: [], error: null };
  }

  try {
    const { data, error } = await supabase.rpc('fuzzy_blend_match', {
      query_text: query.trim(),
    });

    if (error) {
      console.error('Blend search error:', error);
      return { data: null, error };
    }

    return { data: data as BlendMatch[], error: null };
  } catch (err) {
    console.error('Blend search exception:', err);
    return { data: null, error: err as Error };
  }
}

